module.exports = __webpack_public_path__ + "static/media/welcome.7950a8b7.png";